import { Stack, IconButton, Typography, styled, Box } from '@mui/material'

interface IconButtonProps {
  gradiant: string
}
const StyledIconButton = styled(IconButton)<IconButtonProps>(
  ({ theme, gradiant }) => ({
    width: '52px',
    height: '52px',
    padding: '0',
    margin: '0',
    border: 'none',
    borderRadius: '12px',
    boxSizing: 'border-box',
    background: gradiant,
    ...theme.typography.paragraph3,
    '&.Mui-disabled': {
      opacity: '0.5',
    },
    '& path': {
      fill: theme.palette.white,
    },
  }),
)
interface WappNameProps {
  disabled?: boolean
}
const WappNameTypography = styled(Typography)<WappNameProps>(
  ({ theme, disabled }) => ({
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    textAlign: 'center',
    marginTop: '8px',
    ...theme.typography.paragraph3,
    lineHeight: 1.3,
    opacity: disabled ? 0.5 : 1,
  }),
)

const Container = styled(Stack)`
  position: relative;
  align-items: center;
  width: 70px;
  min-height: 90px;
`

interface Props {
  text: string
  icon: JSX.Element
  onClick: () => unknown
  disabled?: boolean
  badge?: JSX.Element
  gradiant: string
}

const BadgeRoot = styled(Box)`
  position: absolute;
  top: -8px;
`

export function ToolBoxWappItemButton({
  text,
  icon,
  onClick,
  disabled,
  badge,
  gradiant,
}: Props) {
  return (
    <Container>
      <StyledIconButton
        onClick={onClick}
        disabled={disabled}
        gradiant={gradiant}
      >
        {icon}
      </StyledIconButton>
      <WappNameTypography disabled={disabled}>{text}</WappNameTypography>
      {badge && <BadgeRoot>{badge}</BadgeRoot>}
    </Container>
  )
}

ToolBoxWappItemButton.defaultProps = {
  disabled: false,
  badge: null,
}
